import { gql } from '@apollo/client';

export const GQL_LOGIN = gql`
  mutation LOGIN($loginData: LoginInput!) {
    login(data: $loginData) {
      userId
      token
    }
  }
`;
